import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { selectSelectedCompany } from "store/companySlice";

import MainContainer from "layout/atoms/MainContainer";
import { Tab, TabsList } from "layout/atoms/Tabs/styles";

export const COMPANY_SETTINGS_PATH = "/admin/settings/company";

function SettingsLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCompany = useSelector(selectSelectedCompany);
  const isPrimaryOwner = selectedCompany?.role === "PRIMARY_OWNER";
  const isCompanyTab = location.pathname.startsWith(COMPANY_SETTINGS_PATH);

  return (
    <MainContainer
      topbar={
        <div>
          <h2>{t("settings.title")}</h2>
        </div>
      }
    >
      {isPrimaryOwner && (
        <TabsList>
          <Tab
            isActive={!isCompanyTab}
            onClick={() => navigate("/admin/settings")}
          >
            {t("settings.tabs.profile")}
          </Tab>
          <Tab
            isActive={isCompanyTab}
            onClick={() => navigate(COMPANY_SETTINGS_PATH)}
          >
            {t("settings.tabs.company")}
          </Tab>
        </TabsList>
      )}
      <Outlet />
    </MainContainer>
  );
}

export default SettingsLayout;
